import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.unfreeze.title',
        defaultMessage: 'Unfreeze card',
    },
    subtitle: {
        id: 'modal.unfreeze.subtitle',
        defaultMessage: 'To unfreeze your card, please contact support',
    },
    contact: {
        id: 'modal.unfreeze.contact',
        defaultMessage: 'Contact support',
    },
    cancel: {
        id: 'modal.unfreeze.cancel',
        defaultMessage: 'Cancel',
    },
})
